export default function isDefined(value) {
    if (typeof value !== 'undefined') {
      return true;
    }
    return false;
}
